'use strict';

var FaresSurchargeUploadImportStatusDirective = function FaresSurchargeUploadImportStatusDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-surcharge-upload-import-status.html'),
    scope: {
      statusId: '@',
      title: '@',
      statusMessage: '=',
      statusClass: '='
    }
  };
};
FaresSurchargeUploadImportStatusDirective.$inject = [];
module.exports = FaresSurchargeUploadImportStatusDirective;